<template>
    <div class="notfound-view">
        <div class="wrapper">
            <div class="image">
                <img src="./../assets/images/not-found.svg">
            </div>
            <p class="title">{{ pageTexts.title[lang] }}</p>
            <div class="actions">
                <router-link class="btn" to="/categories">
                    <span class="btn-text">{{ pageTexts.button[lang] }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            selectedQuestion: 0,
            pageTexts: {
                title: {
                    ua: 'Сторінку не знайдено',
                    ru: 'Страницу не найдено',
                    en: 'Page not found' 
                },
                button: {
                    ua: 'Повернутися до каталогу',
                    ru: 'Вернуться в каталог',
                    en: 'Back to catalog' 
                }
            }
        }
    }, 
    computed: {
        lang() {
            return this.$store.getters['getSelectedLang'];
        }
    }
}
</script>